import { render, staticRenderFns } from "./FormulaExplanationModal.vue?vue&type=template&id=51d05244&scoped=true"
import script from "./FormulaExplanationModal.vue?vue&type=script&lang=js"
export * from "./FormulaExplanationModal.vue?vue&type=script&lang=js"
import style0 from "./FormulaExplanationModal.vue?vue&type=style&index=0&id=51d05244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d05244",
  null
  
)

export default component.exports